// @ts-check
import AppStore from "Stores/AppStore";
import userSettingsStore from "Stores/userSettingsStore";
import ProductMode from "Utils/ProductMode";

export const UserSettingsItems = () => {
    let isDisabled = userSettingsStore.settingsAreLoading === true || userSettingsStore.blockWindow === true || AppStore.modalSettings != null;

    let initData = [
        { id: 'userdl-settings-block', text: 'Должностные лица', icon: 'users-menu' },
        { id: 'sync-settings-block', text: 'Синхронизация', icon: 'us-sync-menu' },
        { id: 'cb-sync-settings-block', text: 'Синхронизация', icon: 'us-sync-menu' },
        { id: 'meeting-sync-settings-block', text: 'Синхронизация', icon: 'us-sync-menu' },
        { id: 'maintance-settings-block', text: 'Обслуживание', icon: 'us-maintance-menu' },
        { id: 'files-settings-block', text: 'Обработка файлов', icon: 'us-file-menu' },
        { id: 'meeting-files-settings-block', text: 'Обработка файлов', icon: 'us-file-menu' },
        { id: 'assistent-settings-block', text: 'Работа с помощником', icon: 'us-assistance-menu' },
        { id: 'cb-assistent-settings-block', text: 'Работа с помощником', icon: 'us-assistance-menu' },
        { id: 'folders-settings-block', text: 'Папки и подпапки', icon: 'us-folders-menu' },
        { id: 'meeting-folders-settings-block', text: 'Папки и подпапки', icon: 'us-folders-menu' },
        { id: 'control-settings-block', text: 'Контроль', icon: 'us-control-menu' },
        { id: 'documents-settings-block', text: 'Работа с документами', icon: 'us-documents-menu' },
        { id: 'resolution-settings-block', text: 'Поручения', icon: 'us-resolutions-menu' },
        { id: 'eds-settings-block', text: 'Электронная подпись', icon: 'us-eds-menu' },
        { id: 'meeting-eds-settings-block', text: 'Электронная подпись', icon: 'us-eds-menu' },
        { id: 'send-eds-settings-block', text: 'Передача сертификата', icon: 'us-eds-transfer-menu' },
        { id: 'annotation-settings-block', text: 'Аннотирование', icon: 'us-annotations-menu' },
        { id: 'other-settings-block', text: 'Доп. параметры', icon: 'other-settings-menu' },
        { id: 'push-settings-block', text: 'Push-уведомления', icon: 'other-settings-menu' },
        { id: 'help-settings-block', text: 'Тех. поддержка', icon: 'us-help-menu' },
        { id: 'personalization-settings-block', text: 'Персонализация', icon: 'personalization' },
    ];

    /** @type {import("./MainItems").LeftPanelItemState[]} */
    let result = ProductMode.FilterControlsParamsObject({
        webKeysVisible: AppStore.productModeSettings?.filterUserSettingsWebKeysVisible,
        webKeysNotVisible: AppStore.productModeSettings?.filterUserSettingsWebKeysNotVisible,
        controlsForFiltering: initData,
        // @ts-ignore
        funcTransformSelect: (item, key) => (
            {
                id: item.id,
                linkTo: "#" + item.id,
                title: item.text,
                icon: item.icon,
                isDisabled: isDisabled,
                isError: false,
                isSelected: false,
                onClick: () => { },
                isAvailable: true,
                relative: true
            }
        ),
        // @ts-ignore
        funcSelectControlKey: (item) => item.id
    });

    let { pageTitle, params } = AppStore.lastPageInfo;
    let returnParams = '';
    // @ts-ignore
    if (pageTitle === 'users' && params != null && params.page != null)
        // @ts-ignore
        returnParams = `?page=${params.page}`;

    result.unshift({
        id: 'back',
        linkTo: `${window.SmrLocation}/users${returnParams}`,
        title: 'Назад',
        icon: 'us-back-menu',
        isDisabled: false,
        isError: false,
        isSelected: true,
        onClick: () => { },
        isAvailable: true
    });

    return result;
};